module.exports = __webpack_public_path__ + "img/undertakingCases26.011aef55.jpg";